<div class="aero-accordion-container">
  <ng-content></ng-content>
</div>
